export default {
  restaurantabout: {
    for: "FOR",
    restaurants: "RESTAURANTS",

    title1: "Source Fresh",
    title2: "Ingredients",
    from: "from",
    highlight: "Trusted Suppliers",

    desc:
      "MAHAL helps restaurants simplify food procurement by connecting them with verified suppliers for daily and bulk sourcing.",

    text:
      "From independent kitchens to multi-branch restaurant chains, MAHAL empowers restaurants with verified suppliers, transparent pricing, and streamlined bulk ordering — all in one unified platform.",

    li1: "Verified Suppliers",
    li2: "Transparent Pricing",
    li3: "Bulk Ordering",
    li4: "On-Time Delivery",

    cta: "Order for Your Restaurant",
  },
};